import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

const PrivacyPolicy = () => (
  <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', display: 'flex', flexDirection: 'column' }}>
    <Header />
    <main style={{ padding: '120px 2rem 2rem', maxWidth: 800, margin: '0 auto', width: '100%', boxSizing: 'border-box', flex: 1, textAlign: 'left' }}>
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> May 24, 2025</p>
      <p>S. Huntley &amp; Co. (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) operates the Bidder iQ website (<a href="https://www.bidderiq.com" target="_blank" rel="noopener noreferrer">https://www.bidderiq.com</a>) and Chrome Extension (&quot;Bidder iQ&quot; or &quot;Service&quot;). This Privacy Policy explains how we collect, use, store, and protect your personal information when you interact with our website or extension.</p>
      <h2>1. Information We Collect</h2>
      <ul>
        <li>Email address (via Clerk authentication)</li>
        <li>Payment data is processed by Stripe (we do not store this data)</li>
        <li>URLs of visited pages (used by the Chrome Extension to display auction insights)</li>
        <li>Local storage data (to track sign-in status on your device)</li>
      </ul>
      <p>We do not collect sensitive personal data such as health, geolocation, or government identification information.</p>
      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Authenticate users via Clerk</li>
        <li>Provide auction data overlays via our Chrome extension</li>
        <li>Process payments via Stripe</li>
        <li>Track basic, anonymized usage metrics for internal analytics</li>
      </ul>
      <p>We do not serve ads, sell user data, or share personal information with third parties for marketing purposes.</p>
      <h2>3. Data Storage and Security</h2>
      <ul>
        <li>User sign-in status is stored using Chrome's local storage.</li>
        <li>Email addresses are managed securely via Clerk.</li>
        <li>We do not permanently store any browsing data or auction page content from users.</li>
        <li>We implement industry-standard security measures to protect your data.</li>
      </ul>
      <h2>4. Third-Party Services</h2>
      <p>Our service integrates with the following third parties:</p>
      <ul>
        <li>Clerk for user authentication</li>
        <li>Stripe for payment processing</li>
        <li>Google Sheets to retrieve auction data</li>
      </ul>
      <p>These services operate under their own privacy policies. We encourage you to review them.</p>
      <h2>5. Cookies and Tracking</h2>
      <p>We do not use cookies or tracking pixels on our website or Chrome extension.</p>
      <h2>6. User Rights</h2>
      <p>If you have created an account via Clerk, you may delete your account at any time. Upon deletion:</p>
      <ul>
        <li>Your email address will be removed from our records</li>
        <li>Any data tied to your user profile will no longer be accessible</li>
      </ul>
      <p>If you are a resident of the European Union (GDPR) or California (CCPA), you may also:</p>
      <ul>
        <li>Request access to your data</li>
        <li>Request deletion of your data</li>
      </ul>
      <p>Contact us with any privacy concerns at: <a href="mailto:dwhitlock@shuntley.co">dwhitlock@shuntley.co</a></p>
      <h2>7. Data Sharing and Disclosure</h2>
      <p>We do not sell, trade, or rent your personal data to third parties. We may disclose your information if required by law or in response to valid legal process.</p>
      <h2>8. International Users</h2>
      <p>While we operate in the United States (Bethlehem, Pennsylvania), Bidder iQ is accessible worldwide. If you are accessing the service from outside the U.S., your data may be processed and stored in the U.S.</p>
      <h2>9. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be reflected on this page with a revised effective date. We encourage users to review this policy periodically.</p>
      <h2>10. Contact Us</h2>
      <address>
        <p>S. Huntley &amp; Co.<br />
        116 Research Drive, Suite 2214<br />
        Bethlehem, PA 18015<br />
        <span role="img" aria-label="email">📧</span> <a href="mailto:dwhitlock@shuntley.co">dwhitlock@shuntley.co</a></p>
      </address>
    </main>
    <Footer />
  </div>
);

export default PrivacyPolicy;
